import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import { AuthProvider } from "@/contexts/AuthContext";
import { CustomerAuthProvider } from "@/contexts/CustomerAuthContext";
import { SiteContentProvider } from "@/contexts/SiteContentContext";
import HomePage from "@/pages/Home";
import CaseDetail from "@/pages/CaseDetail";
import Loja from "@/pages/Loja";
import ComoFunciona from "@/pages/ComoFunciona";
import CheckoutSuccess from "@/pages/CheckoutSuccess";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import OsMeusCasos from "@/pages/OsMeusCasos";
import Contacto from "@/pages/Contacto";
import RecuperarPassword from "@/pages/RecuperarPassword";
import RedefinirPassword from "@/pages/RedefinirPassword";
import AuthCallback from "@/pages/AuthCallback";
import AuthRecoveryListener from "@/components/AuthRecoveryListener";

function App() {
  return (
    <div className="App">
      <SiteContentProvider>
        <CustomerAuthProvider>
          <AuthProvider>
            <BrowserRouter>
              <AuthRecoveryListener />
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/casos" element={<Loja />} />
                <Route path="/casos/:slug" element={<CaseDetail />} />
                <Route path="/loja" element={<Loja />} />
                <Route path="/como-funciona" element={<ComoFunciona />} />
                <Route path="/contacto" element={<Contacto />} />
                <Route path="/checkout/sucesso" element={<CheckoutSuccess />} />
                <Route path="/entrar" element={<Login />} />
                <Route path="/criar-conta" element={<Signup />} />
                <Route path="/recuperar-password" element={<RecuperarPassword />} />
                <Route path="/redefinir-password" element={<RedefinirPassword />} />
                <Route path="/reset-password" element={<RedefinirPassword />} />
                <Route path="/auth/callback" element={<AuthCallback />} />
                <Route path="/os-meus-casos" element={<OsMeusCasos />} />
                <Route path="/meus-casos" element={<OsMeusCasos />} />
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/admin" element={<AdminDashboard />} />
              </Routes>
            </BrowserRouter>
          </AuthProvider>
        </CustomerAuthProvider>
      </SiteContentProvider>
    </div>
  );
}

export default App;
